<div class="file-display">
  <span style="text-decoration:underline; color:blue;cursor:pointer" (click)="downloadFile($event)">{{dataItem[fileNameColumnName]}}</span>
  <span *ngIf="(dataItem[fileNameColumnName] != null && editable)" style="float:right; cursor:pointer">
    <aims-common-button-mini
          title="Delete"
          aria-label="Delete"
          (click)="uploadRemove($event)">
        <mat-icon color="warn">delete</mat-icon>
      </aims-common-button-mini>
  </span>
  <!-- <span *ngIf="!m.alreadyExists(dataItem, primaryKeyName)" style="color:red">Not Saved!</span> -->
</div>
